import { render, staticRenderFns } from "./DrawerFamilyTab.vue?vue&type=template&id=53acd269&scoped=true"
import script from "./DrawerFamilyTab.vue?vue&type=script&lang=js"
export * from "./DrawerFamilyTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerFamilyTab.vue?vue&type=style&index=0&id=53acd269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53acd269",
  null
  
)

export default component.exports